import React from 'react';
import PropTypes from 'prop-types';
import TestimonialSlider from 'components/testimonial-slider';

export default function Pickers({ title, pickers, subtitle }) {
    return (
        <div className="cms-pickers">
            <div className="cms-pickers--title">{title}</div>
            {subtitle && <div className="cms-pickers--subtitle">{subtitle}</div>}
            <div className="cms-pickers--slider">
                <TestimonialSlider pickers={pickers.pickers} />
            </div>
        </div>
    );
}

Pickers.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    pickers: PropTypes.shape({
        pickers: PropTypes.array.isRequired,
    }),
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/testimonials/index.js